import type { PermissionData } from '../types'

export function computeCreateGeofencePermission(permissionData: PermissionData) {
  if (permissionData.rmOnly || permissionData.hasNoPhysicalDevices) return 'hidden'

  return 'enabled'
}
